import { Link } from 'react-router-dom';

export default function CtaBand() {
  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-14 md:px-8 md:py-20">
        <div className="paper-grain overflow-hidden rounded-lg border border-primary-200 bg-primary-50">
          <div className="grid grid-cols-1 items-center gap-8 p-8 md:p-12 lg:grid-cols-12">
            <div className="lg:col-span-8">
              <span className="font-label text-xs tracking-[0.3em] text-primary-600">线索投稿 / CONTRIBUTE</span>
              <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
                手上有没头绪的片段？交给我们排一遍时间线
              </h2>
              <p className="mt-4 max-w-2xl font-body text-sm leading-relaxed text-foreground-700 md:text-base">
                一段录屏、一次截图、一句被忽略的发言，都可能补上缺失的那一格。请尽量附上原始素材出现的时间与来源，方便我们做交叉核对。
              </p>
            </div>
            <div className="flex flex-col gap-3 lg:col-span-4">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-send-plane-line text-base" />
                提交线索
              </Link>
              <Link
                to="/dossiers"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-300 px-6 py-3 font-label text-sm text-primary-700 transition-colors hover:border-primary-500"
              >
                <i className="ri-book-open-line text-base" />
                先看档案库
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}